import React from "react"
import * as TablerIcons from "@tabler/icons-react"

// ==============================================================================
// ALERT REVIEW/ACTION UTILITIES
// ==============================================================================

/**
 * Format action type to human-readable text
 */
export const formatActionType = (actionType: string): string => {
  switch (actionType) {
    case "comment":
      return "added a comment"
    case "resolve":
      return "resolved the alert"
    case "dismiss":
      return "dismissed as false positive"
    case "escalate":
      return "escalated the alert"
    case "assign":
      return "assigned the alert"
    case "view":
      return "viewed the alert"
    case "reopen":
      return "reopened the alert"
    default:
      return "performed an action"
  }
}

/**
 * Get icon for action type
 */
export const getActionIcon = (
  actionType: string,
  size: number = 16
): React.ReactNode => {
  switch (actionType) {
    case "comment":
      return <TablerIcons.IconMessageCircle size={size} />
    case "resolve":
      return <TablerIcons.IconCheck size={size} />
    case "dismiss":
      return <TablerIcons.IconX size={size} />
    case "escalate":
      return <TablerIcons.IconArrowUp size={size} />
    case "assign":
      return <TablerIcons.IconUserPlus size={size} />
    case "view":
      return <TablerIcons.IconAlertCircle size={size} />
    case "reopen":
      return <TablerIcons.IconAlertCircle size={size} />
    default:
      return <TablerIcons.IconMessage size={size} />
  }
}

/**
 * Get color class for action type
 */
export const getActionColor = (actionType: string): string => {
  switch (actionType) {
    case "comment":
      return "text-blue-600"
    case "resolve":
      return "text-green-600"
    case "dismiss":
      return "text-gray-600"
    case "escalate":
      return "text-red-600"
    case "assign":
      return "text-purple-600"
    case "view":
      return "text-gray-500"
    default:
      return "text-gray-600"
  }
}
